import React from 'react'
import { styled } from 'styled-components'
import type { ClientQuestion, ClassScore } from '@mission.io/question-toolkit'
import { Question } from '@mission.io/question-views'
import { cssPlayerHeightUnit } from '../../../../utility/constants'
import type { Score } from './types'

/**
 * QuestionModal - A modal used to view how the class did on a question
 *
 * @param  {Object} props - the react props
 * @param  {ClientQuestion} props.question - the question to show
 * @param  {Score} props.score - the conglomerated score of the class on the question
 * @param  {ClassScore} props.classScore - data of how the entire class answered the question
 * @param  {number} props.index - the question number
 *
 * @returns React$Node
 */
export default function QuestionModal({
	question,
	score,
	classScore,
	onDismiss,
	questionNumber,
}: {
	question: ClientQuestion,
	score: Score,
	classScore: ClassScore,
	onDismiss: () => void,
	questionNumber: number,
}): React$Node {
	const classResponse = {
		generalScore: score.correct / score.outOf,
		scores: classScore,
	}
	return (
		<StyledModalBackground onClick={onDismiss}>
			<StyledModal>
				<Question
					question={question}
					review="INSTANT"
					questionIndex={questionNumber}
					requestId="hello"
					classResponse={classResponse}
				/>
			</StyledModal>
		</StyledModalBackground>
	)
}

const StyledModalBackground = styled.div`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: #000000a0;
	z-index: 1;
`

const StyledModal = styled.div`
	position: absolute;
	top: ${cssPlayerHeightUnit(5)};
	bottom: ${cssPlayerHeightUnit(20)};
	left: ${cssPlayerHeightUnit(5)};
	right: ${cssPlayerHeightUnit(5)};
	background-color: #5c5790;
	border-radius: ${cssPlayerHeightUnit(2)};
	overflow-y: auto;
	font-size: ${cssPlayerHeightUnit(3)};
	padding: ${cssPlayerHeightUnit(4)};
`
